import angular from 'angular';
import UtilsService from './utils-service';

const utils = angular.module('utils', []);

utils.service('utils', UtilsService);

export default utils.name;
